<template>
  <div>
    <mixed-table
        :data="data"
        :columns="columns"
        :fetch-data="getData"
        :row-clicked="selectData"
        :reload-table="reloadTable"/>
  </div>
</template>

<script>
import MixedTable from "../../components/Table/MixedTable";
import {SmsAxios} from "../../../main";
import {debounce} from "@/main";
import checkboxFiled from "../admin/components/checkboxFiled";

export default {
  name: "patternsList",

  components: {MixedTable, checkboxFiled},

  props: {
    value: Object
  },

  data() {
    return {
      loading: false,
      priceDialog: false,
      isEditing: false,
      data: {},
      tableProps: {
        page: 1,
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      description: {
        id: '',
        desc: ''
      },
      columns: [
        {
          label: '',
          component: checkboxFiled,
          event: 'change',
          meta: {
            id: () => this.selectedPattern
          },
          handler: this.changed
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
        },
        {
          label: 'عنوان',
          name: 'title',
          primary: true
        },
        {
          label: 'متن پترن',
          name: 'content',
        },
      ],
    }
  },

  mounted() {
    // window.Vue.$on('selectAllListCheckBox', (e) => {
    //   this.selectAll(e.checked);
    // })

    this.getData()
  },

  computed: {
    selectedPattern() {
      return this.description.id
    }
  },

  watch: {
    description: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true
    }
  },

  methods: {
    selectData(e) {
      this.description = {
        content: e.content,
        desc: e.desc,
        id: e.id
      }
    },
    getData(query = this.tableProps) {
      this.loading = true;

      SmsAxios.get('admin/text', {
        params: query
       }).then(response => {
        this.data = response.data;
        this.$emit('count', response.data.data.length)
      }).catch(reason => {
        this.$modal.error('خطا', 'در دریافت اطلاعات با خطا مواجه‌ شدیم.');

      }).finally(() => {
        this.loading = false;
      });
    },
    reloadTable(tableProps) {
      debounce(() => {
        this.tableProps.page = this.data.current_page;
        this.getData(tableProps);
      }, 1000);
    },
    changed(data, n) {
      this.description.id = n ? data.id : ''
    }
  }
}
</script>

<style scoped>

</style>